/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type ReportSvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function ReportSvgIcon(props: ReportSvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      className={classNames("plasmic-default__svg", className, "icon")}
      version={"1.1"}
      viewBox={"0 0 1024 1024"}
      height={"1em"}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"#D72822"}
        d={
          "M687.543 965.486H182.857c-87.771 0-160.914-73.143-160.914-160.915V256c0-87.771 73.143-160.914 160.914-160.914h336.457v51.2H182.857c-58.514 0-109.714 51.2-109.714 109.714v541.257c0 58.514 51.2 109.714 109.714 109.714h504.686c58.514 0 109.714-51.2 109.714-109.714V533.943h58.514v263.314c-7.314 95.086-80.457 168.229-168.228 168.229"
        }
      ></path>

      <path
        fill={"#F4B1B2"}
        d={
          "M877.714 95.086 987.43 234.057c7.314 7.314 0 14.629-7.315 21.943L629.03 526.629c-7.315 7.314-160.915-7.315-160.915-7.315s29.257-146.285 36.572-153.6L855.77 95.086q10.972-10.972 21.943 0"
        }
      ></path>

      <path
        fill={"#D72822"}
        d={
          "M607.086 555.886c-21.943 0-65.829 0-138.972-7.315h-29.257V512c29.257-160.914 36.572-160.914 43.886-168.229L833.829 73.143c21.942-14.629 43.885-14.629 58.514 7.314l109.714 138.972c14.629 14.628 7.314 43.885-7.314 58.514L643.657 548.57c-7.314 7.315-7.314 7.315-36.571 7.315M497.37 497.37c51.2 0 95.086 7.315 117.029 7.315L950.857 241.37l-87.771-117.028-336.457 263.314C519.314 402.285 512 446.17 497.371 497.37"
        }
      ></path>
    </svg>
  );
}

export default ReportSvgIcon;
/* prettier-ignore-end */
